function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.747 6.253a.863.863 0 010 1.22L10.221 9l1.526 1.526a.863.863 0 01-1.22 1.221L9 10.221l-1.526 1.526a.863.863 0 01-1.221-1.22L7.779 9 6.253 7.474a.863.863 0 011.22-1.221L9 7.779l1.526-1.526a.863.863 0 011.221 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgMicro = function SvgMicro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18
    }, props), _ref)
  );
};

export default SvgMicro;